import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';

class BlueHeroSlider extends Component {
	getCatLink( parent_child_cats ) {
		let link = `/category/${ parent_child_cats.parent.slug }/`;
		if ( parent_child_cats.parent.term_id !== parent_child_cats.child.term_id ) {
			link += `${ parent_child_cats.child.slug }/`;
		}
		return link;
	}

	renderPostDate( post ) {
		if ( post.hide_date_tag_list ) {
			return '';
		}

		return (<span
				className="published-date">{ post.formatted_date }</span>
		);
	}

	renderPostCategory( post ) {
		if ( post.hide_category_tag_list ) {
			return '';
		}
		return (<a href={`?subcategories=${post.parent_child_cats.child.term_id}`} className={ 'category-link' }
		              dangerouslySetInnerHTML={ { __html: post.parent_child_cats.child.name } }/>
		);
	}

	renderEntryMeta( post ) {
		if ( post.parent_child_cats.child.name !== undefined && post.parent_child_cats.child.name === 'FpML' ) {
			return (<div className="entry-meta">
					<Link
						to={ `/category/${ post.parent_child_cats.parent.slug }/` }
						className="category-icon-link">
						<span
							className={ `category-icon category-${ post.parent_child_cats.parent.slug }` }
							aria-hidden="true"></span>
						<span
							className="sr-only">{ post.parent_child_cats.parent.name }</span>
					</Link>
				</div>
			);
		}  else {
			return (<div className="entry-meta">
					{/*{ this.renderPostCategory( post ) }*/ }

					{/*{ this.renderPostDate( post ) }*/ }
					<div className="d-flex">
						<div className="icon-chip">
							<Link
								to={ `/category/${ post.parent_child_cats.parent.slug }/` }
								className="category-icon-link">
						<span
							className={ `category-icon category-${ post.parent_child_cats.parent.slug }` }
							aria-hidden="true"></span>
								<span
									className="sr-only">{ post.parent_child_cats.parent.name }</span>
							</Link>
						</div>
						<div className="d-flex">
							<div className="entry-category-wrap">
								{ this.renderPostCategory( post ) }
								{ this.renderPostDate( post ) }
							</div>
						</div>
					</div>
					<div className="d-flex">
						{/* <div className="read-time">
						 <svg width="16" height="17" viewBox="0 0 16 17"
						 fill="none"
						 xmlns="http://www.w3.org/2000/svg">
						 <g clip-path="url(#clip0_1480_577)">
						 <path
						 d="M8 16.5C3.58867 16.5 0 12.9113 0 8.5C0 4.08867 3.58867 0.5 8 0.5C12.4113 0.5 16 4.08867 16 8.5C16 12.9113 12.4113 16.5 8 16.5ZM8 1.83333C4.324 1.83333 1.33333 4.824 1.33333 8.5C1.33333 12.176 4.324 15.1667 8 15.1667C11.676 15.1667 14.6667 12.176 14.6667 8.5C14.6667 4.824 11.676 1.83333 8 1.83333ZM11.3333 8.5C11.3333 8.13133 11.0353 7.83333 10.6667 7.83333H8.66667V4.5C8.66667 4.13133 8.368 3.83333 8 3.83333C7.632 3.83333 7.33333 4.13133 7.33333 4.5V8.5C7.33333 8.86867 7.632 9.16667 8 9.16667H10.6667C11.0353 9.16667 11.3333 8.86867 11.3333 8.5Z"
						 fill="#C6A57D"></path>
						 </g>
						 <defs>
						 <clipPath id="clip0_1480_577">
						 <rect width="16" height="16"
						 fill="white"
						 transform="translate(0 0.5)"></rect>
						 </clipPath>
						 </defs>
						 </svg>
						 (N) min read
						 </div> */ }
					</div>
				</div>
			);
		}
	}

	renderEventEntryMeta( post ) {
		return <div className="entry-meta">
			<div className="d-flex">
				<div className="d-flex">
					{ post.parent_child_cats.parent.slug && <div
						className="icon-chip">
						<a
							href={ `${ location.origin }/category/${ post.parent_child_cats.parent.slug }/` }
							className="category-icon-link">
						<span
							className={ `category-icon category-${ post.parent_child_cats.parent.slug }` }
							aria-hidden="true"></span>
							<span
								className="sr-only">{ post.parent_child_cats.parent.name }</span>
						</a>
					</div> }
					<div className="d-flex">
						<div className="entry-category-wrap">
							{/*{ this.renderPostCategory( post ) }*/ }
							{/*{ this.renderPostDate( post ) }*/ }
						</div>
					</div>
				</div>
				<div className="entry-category-wrap">
					<span
						className="category-link">{ post.formatted_date }</span>
					<span className="published-date">{ post.city.name }</span>
				</div>

			</div>
			{/* Need to check imis code to see if it's an event */ }
			{ post.imis_code && (<div className="d-flex">
					<div className="bookmark"><i
						className={ `fa-bookmark toggle-bookmark ${ ISDA_Main.userBookmarks.includes( post.id )
						                                            ? 'fa'
						                                            : 'fa-regular' }` }
						data-post-id={ post.id }></i></div>
				</div>
			) }
		</div>;
	}

	renderExcerpt( post ) {
		if ( post.parent_child_cats.child.name !== 'FpML' && post.post_format !== 'image' ) {
			return (<div className="entry-content"
			             dangerouslySetInnerHTML={ { __html: post.excerpt } }/>
			);
		}

		if ( post.parent_child_cats.child.name === 'FpML' && post.post_format !== 'image' ) {
			return (<a href="http://www.fpml.org/">
					<img src={ post.fpml_logo_url } alt="" role="presentation"
					     className="fpml-logo"/>
				</a>
			);
		}

		if ( post.post_format === 'image' && post.alternative_image.length > 0 ) {
			return (<div>
					<img src={ post.alternative_image } alt=""
					     role="presentation" className="image-alternative"/>
				</div>
			);
		}

		return '';
	}

	renderEventExcerpt( post ) {
		return <div className="event-excerpt" dangerouslySetInnerHTML={ { __html: post.excerpt } } />;
	}

	renderEventButtons( post ) {
		return post ? <div className="events-slider-buttons buttons-center">
			<a className="btn btn-default outlined"
			   href={ post.link }>Details</a>
			{ post.registration && <a className="btn btn-default"
			                              href={ post.registration_url }>Register</a> }
		</div> : <div></div>;
	}

	getFeaturedPostsArray( maxPosts = 5 ) {
		const categories = {};
		const result = [];

		// Group posts by category
		this.props.featured.forEach( post => {
			if ( !categories[ post.cat_slug ] ) {
				categories[ post.cat_slug ] = [];
			}
			categories[ post.cat_slug ].push( post );
		} );

		let index = 0;
		let added = true;

		// Keep adding posts until we reach the maxPosts limit or run out of posts
		while ( result.length < maxPosts && added ) {
			added = false;

			for ( let cat_slug of Object.keys( categories ) ) {
				const categoryPosts = categories[ cat_slug ];

				if ( categoryPosts[ index ] ) {
					result.push( categoryPosts[ index ] );
					added = true;

					// Stop if we have filled the result array
					if ( result.length === maxPosts ) {
						return result;
					}
				}
			}

			index++;
		}

		return result;
	}

	render() {
		const { featured, isEvent } = this.props;

		const settings = {
			dots          : true,
			infinite      : true,
			autoplay      : true,
			speed         : 500,
			autoplaySpeed : 5000,
			slidesToShow  : 1,
			slidesToScroll: 1
		};
		if ( featured.length ) {
			//You can get all the top 5 featured posts with this.props.
			const featuredPosts = isEvent
			                      ? featured[ 0 ]
			                      : this.getFeaturedPostsArray( 4 );

			return (<div className="blue-hero-single row no-gutter">
					<Slider { ...settings }>
						{ featuredPosts.map( ( post ) => {
							return <div key={ post.id }
							            className="blue-hero-slide">
								<div
									className={ `blue-hero-slide-image ${ isEvent
									                                      ? 'tall'
									                                      : '' }` }
									style={ { backgroundImage: `url(${ post.thumbnail })` } }></div>
								<div className="blue-hero-slide-content">
									<div className={ `content-wrapper ${ isEvent ? 'event-content-wrapper' : '' }` }>
										{ isEvent
										  ? this.renderEventEntryMeta( post )
										  : this.renderEntryMeta( post ) }
										<a href={ post.link }
										   className="entry-title-link">
											<h2 className="entry-title">{ isEvent
											                              ? post.title
											                              : post.trimmed_title }</h2>
										</a>
										{ isEvent
										  ? this.renderEventExcerpt( post )
										  : this.renderExcerpt( post ) }
										{ isEvent && this.renderEventButtons( post ) }
									</div>
								</div>
							</div>;
						} ) }
					</Slider>
				</div>
			);
		} else {
			return <div></div>;
		}
	}
}

function mapStateToProps( { categories } ) {
	return { categories };
}

export default connect( mapStateToProps )( BlueHeroSlider );